import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "segment",
    "input",
    "label",
    "clear",
    "dropdown",
    "search",
    "list",
    "empty"
  ]

  static values = {
    anySpecialization: String
  }

  connect() {
    this.syncFromInput()
    this.boundDocumentClick = this.handleDocumentClick.bind(this)
    document.addEventListener("click", this.boundDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.boundDocumentClick)
  }

  prepareSubmit() {
    if (!this.inputTarget.value) this.inputTarget.disabled = true
    this.closeDropdown()
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target)) return
    this.closeDropdown()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  toggle(event) {
    if (event.target.closest(".hero-search__date-clear")) return
    if (event.target.closest(".hero-search__dropdown--specialization")) return

    event.preventDefault()

    if (this.isOpen()) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  clear(event) {
    event.preventDefault()
    event.stopPropagation()
    this.setAny()
    this.dispatchChange()
  }

  filter() {
    const query = this.searchTarget?.value.trim().toLowerCase() ?? ""
    const list = this.listTarget
    if (!list) return

    const anyOption = list.querySelector(".hero-search__specialization-option--any")
    if (anyOption) anyOption.classList.toggle("hidden", query.length > 0)

    let visibleOptions = 0
    list.querySelectorAll(".hero-search__specialization-group").forEach((group) => {
      let groupVisible = 0

      group.querySelectorAll(".hero-search__specialization-option").forEach((button) => {
        const keywords = (
          button.dataset.specializationKeywords
          ?? button.dataset.specializationName
          ?? button.textContent
        ).trim().toLowerCase()
        const match = !query || keywords.includes(query)
        button.classList.toggle("hidden", !match)
        if (match) groupVisible++
      })

      group.classList.toggle("hidden", groupVisible === 0)
      visibleOptions += groupVisible
    })

    if (this.hasEmptyTarget) {
      const showEmpty = query.length > 0 && visibleOptions === 0
      this.emptyTarget.classList.toggle("hidden", !showEmpty)
    }
  }

  openDropdown() {
    this.dropdownTarget.classList.remove("hidden")
    this.segmentTarget.classList.add("hero-search__segment--dropdown-open")
    this.resetSearch()
    this.syncFromInput()
  }

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden")
    this.segmentTarget.classList.remove("hero-search__segment--dropdown-open")
    this.resetSearch()
  }

  isOpen() {
    return !this.dropdownTarget.classList.contains("hidden")
  }

  resetSearch() {
    if (this.hasSearchTarget) this.searchTarget.value = ""

    this.listTarget.querySelectorAll(".hero-search__specialization-group.hidden").forEach((group) => {
      group.classList.remove("hidden")
    })
    this.listTarget.querySelectorAll(".hero-search__specialization-option.hidden").forEach((button) => {
      button.classList.remove("hidden")
    })
    if (this.hasEmptyTarget) this.emptyTarget.classList.add("hidden")
  }

  selectOption(event) {
    const button = event.target.closest(".hero-search__specialization-option")
    if (!button || !this.dropdownTarget.contains(button)) return

    event.preventDefault()
    event.stopPropagation()
    this.applySelection(button.dataset.specializationId, button.dataset.specializationName)
  }

  applySelection(id, name) {
    if (!id) {
      this.setAny()
    } else {
      this.inputTarget.disabled = false
      this.inputTarget.value = id
      this.labelTarget.textContent = name
      this.clearTarget.classList.remove("hidden")
      this.markOption(id)
    }
    this.closeDropdown()
    this.dispatchChange()
  }

  setAny() {
    this.inputTarget.value = ""
    this.labelTarget.textContent = this.anySpecializationValue
    this.clearTarget.classList.add("hidden")
    this.markOption("")
  }

  syncFromInput() {
    const selectedId = this.inputTarget.value ?? ""
    if (!selectedId) {
      this.markOption("")
      return
    }

    const activeButton = this.dropdownTarget.querySelector(
      `.hero-search__specialization-option[data-specialization-id="${selectedId}"]`
    )
    if (activeButton) {
      this.labelTarget.textContent = activeButton.dataset.specializationName
      this.clearTarget.classList.remove("hidden")
      this.markOption(selectedId)
    }
  }

  markOption(selectedId) {
    this.dropdownTarget.querySelectorAll(".hero-search__specialization-option").forEach((button) => {
      const active = button.dataset.specializationId === selectedId
      button.classList.toggle("hero-search__date-quick-btn--active", active)
    })
  }

  dispatchChange() {
    this.dispatch("change")
  }
}
